import React, { useState, useEffect } from 'react';
import CLSlides from './CLSlides';

function CLBody() {
  const [clData, setCLData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/content/cuisineLocative/cuisineLocative.json');
        const data = await response.json();
        setCLData(data);
      } catch (error) {
        console.error('Error fetching Cuisine Locative data:', error);
      }
    };

    fetchData();
  }, []);

  if (!clData) {
    return <div className="loadingFiller"></div>;
  }

  const clListItems = Object.keys(clData.body.liste.items).map((i) => (
    <li key={i}>{clData.body.liste.items[i]}</li>
  ));

  return (
    <>
      <div className="clBlackBG">
        <img 
          src="/home/bg/slateBackgroung.svg" 
          alt="" 
          className="clBgOverlay" 
          aria-hidden="true"
        />
        {/* Hero Section */}
        <section className="clHeroSection">
          <div className="clHeroContent">
            <h2 className="CLDesktop clMainTitle">Cuisine Locative</h2>
            <div className="clHeroDivider"></div>
            <h1 className="clHeroTitle">{clData.body.title}</h1>
            {/* <p className="clHeroSubtitle">{clData.body.paragraphe_1}</p> 
            <div className="clHeroStats">
              <div className="clHeroStat">
                <span className="clHeroStatNumber">1300</span>
                <span className="clHeroStatLabel">pi²</span>
              </div>
              <div className="clHeroStatDivider"></div>
              <div className="clHeroStat">
                <span className="clHeroStatNumber">MAPAQ</span>
                <span className="clHeroStatLabel">conforme</span>
              </div>
              <div className="clHeroStatDivider"></div>
              <div className="clHeroStat">
                <span className="clHeroStatNumber">100%</span>
                <span className="clHeroStatLabel">équipé</span>
              </div>
            </div>*/}
            <p className="clHeroDescription">{clData.body.paragraphe_2}</p>
          </div>
        </section>

        {/* Main Content Section */}
        <section className="clContentSection">
          <div className="clContentWrapper">

            {/* Services Grid */}
            <div className="clServicesSection">
              <h3 className="clSectionTitle">{clData.body.liste.title}</h3>
              <div className="clServicesGrid">
                {Object.keys(clData.body.liste.items).map((i) => (
                  <div key={i} className="clServiceCard">
                    <div className="clServiceIcon">✓</div>
                    <p className="clServiceText">{clData.body.liste.items[i]}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA Button */}
            <div className="clCtaSection">
              <a href='/contact?cuisinelocative' className="clCtaButton">{clData.body.button}</a>
            </div>
          </div>
        </section>

        {/* Image Gallery */}
        <section className="clGallerySection">
          <CLSlides />
        </section>

        {/* Clients Section */}
        <section className="clClientsSection">
          <div className="clClientsHeader">
            <h3 className="clSectionTitle">Nos clients</h3>
            <div className='clDivider'></div>
          </div>
          <p className="clClientsDescription">{clData.body.clients_description}</p>
        </section>
      </div>
    </>
  );
}

export default CLBody;
